<template>
  <div class="bg-dim flex-col">
    <div class="pwInputWrap">
      <button type="button" class="btn-close"><img src="@/assets/images/btn-closePw.svg" alt="닫기" @click="closeKeyboard" /></button>
      <div class="pwStats">
        <h2>이마티콘 <br />비밀번호 입력</h2>
        <ul class="pw-number">
          <li v-for="(item, index) in Array(6).fill(0)" :key="index" :class="{ active: index < inputPassword.length }" />
        </ul>
        <p class="error" v-if="certifiedRestriction">
          오류 횟수(<span>{{ certifiedRequestCount }}</span
        >/{{ certifiedRestrictionCount }})
        </p>
        <p class="pwFind"><button type="button" @click="$router.push({ name: 'setting' })">비밀번호를 잊으셨나요? ></button></p>
      </div>
      <div class="setupBio">
        <div class="buttonBlock" @click="handleBioSet" v-if="fidoYn === 'N'">
          <button type="button">
            <img src="@/assets/images/ico-bio.svg" alt="" class="ico" />
            생체인증 설정하러 가기
            <img src="@/assets/images/ico-bio-arrow.svg" alt="" class="arrow" />
          </button>
        </div>
      </div>
      <ul class="keypadWrap">
        <li><button type="button" @click="handleNumberClick('1')">1</button></li>
        <li><button type="button" @click="handleNumberClick('2')">2</button></li>
        <li><button type="button" @click="handleNumberClick('3')">3</button></li>
        <li><button type="button" @click="handleNumberClick('4')">4</button></li>
        <li><button type="button" @click="handleNumberClick('5')">5</button></li>
        <li><button type="button" @click="handleNumberClick('6')">6</button></li>
        <li><button type="button" @click="handleNumberClick('7')">7</button></li>
        <li><button type="button" @click="handleNumberClick('8')">8</button></li>
        <li><button type="button" @click="handleNumberClick('9')">9</button></li>
        <li></li>
        <li><button type="button" @click="handleNumberClick('0')">0</button></li>
        <li><button type="button" class="delete" @click="handleDeleteClick">뒤로</button></li>
      </ul>
    </div>
  </div>
</template>
<script>
import AlertPopup from '@/views/myemarticon/alertPopup.vue';

export default {
  name: 'Keyboard',
  components: { 'alert-popup': AlertPopup, 'password-popup': AlertPopup },
  props: ['certifiedRequestCount', 'certifiedRestriction', 'certifiedRestrictionCount', 'barcodeNo', 'showKeyboard'],
  data() {
    return {
      showAlertPopup: false,
      alertMessage: '',
      mberPassword: '',
      inputPassword: [],
      currentIndex: 0,

      // visibilityEvent: false,
    };
  },
  async mounted() {
    if(this.$store.state.nativeStore.isApp && this.$props.showKeyboard) {

      await this.$store.commit("nativeStore/init");

      await this.$store.dispatch('nativeStore/getFidoYn');
    }
  },
  computed: {
    fidoYn() {
      return this.$store.state.nativeStore.fidoYn;
    },
    authYn() {
      return this.$store.state.nativeStore.authYn;
    },
  },
  watch: {
    inputPassword(value) {
      if (value.length === 6) {
        this.enterEmarticonPassword();
      }
    },
    fidoYn(value) {
      if(value === 'Y' && !this.$store.state.nativeStore.useBioAuth) {
        this.$store.dispatch('nativeStore/useFidoYn', { barcodeNo: this.$props.barcodeNo });
      }
    },
    authYn(value) {
      if(value === 'Y') {
        this.$emit('closeKeyboardBio');
      }
    },
  },
  methods: {
    /**
     * 숫자 클릭 시 처리
     */
    handleNumberClick(value) {
      if (this.currentIndex >= 6) return;
      this.inputPassword.push(value);
      this.currentIndex++; // 인덱스 증가
    },
    /**
     * 삭제 버튼 클릭 시 처리
     */
    handleDeleteClick() {
      if (this.currentIndex <= 0) return;
      this.inputPassword.pop();
      this.currentIndex--;
    },
    /**
     * 이마티콘 회원 비밀번호 검증
     */
    enterEmarticonPassword() {
      this.mberPassword = this.inputPassword.join('');
      this.$emit('enterEmarticonPassword', this.mberPassword);
      this.resetPasswordInput();
    },
    /**
     * 이마티콘 회원 비밀번호 입력 초기화
     */
    resetPasswordInput() {
      this.inputPassword = [];
      this.currentIndex = 0;
    },
    /**
     * 이마티콘 회원 비밀번호 입력 팝업 닫기
     */
    closeKeyboard() {
      this.$emit('closeKeyboard');
    },
    /**
     * 이마티콘 생체인증 설정
     */
    handleBioSet() {
      // this.$emit('closeKeyboard');

      window.location.href = process.env.VUE_APP_EMART_BIO;
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/common/pwInputPage.scss';
</style>
